export const PUSH_TO_FI_REQUEST = 'PUSH_TO_FI_REQUEST';
export const PUSH_TO_FI_SUCCESS = 'PUSH_TO_FI_SUCCESS';
export const PUSH_TO_FI_FAILURE = 'PUSH_TO_FI_FAILURE';
export const PUSH_TO_FI_OFFER_SAVE_FAILURE_EVENT = 'PUSH_TO_FI_OFFER_SAVE_FAILURE_EVENT';
export const PUSH_TO_FI_DEAL_REF_ID_TIMEOUT_EVENT = 'PUSH_TO_FI_DEAL_REF_ID_TIMEOUT_EVENT';
export const CONFIRM_PUSH_TO_FI = 'CONFIRM_PUSH_TO_FI';
export const UPDATE_PUSH_TO_FI = 'UPDATE_PUSH_TO_FI';
export const CLEAR_PUSH_TO_FI_CACHE = 'CLEAR_PUSH_TO_FI_CACHE';
